import styled from 'styled-components';

import { media, layout } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';

export const ConfirmRearrangeButton = styled(Button)`
  ${media.mediumUp`
    display: none;
  `};

  width: 100%;
`;

export const ConfirmRearrangeButtonWrapper = styled.div`
  padding-left: ${layout.spacing.xSmall};
  padding-right: ${layout.spacing.xSmall};
  margin-bottom: ${layout.spacing.xSmall};
`;
